import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ReferralInfo } from './types'

export type ReferralState = {
  data?: ReferralInfo
  fetching: boolean
  hasError: boolean
}

export const initialState: ReferralState = {
  fetching: false,
  hasError: false
}

const configSlice = createSlice({
  initialState,
  name: 'referral',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    reset() {
      return initialState
    },
    setInfo(state, action: PayloadAction<ReferralInfo>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = configSlice
export default configSlice.reducer
